module.exports = __webpack_public_path__ + "static/media/at.a8ebc374.svg";